import React from "react";
import { Link } from "react-router-dom";

function CTASection() {
  return (
    <section className="w-full  py-16 px-4">
      <div className="max-w-4xl mx-auto text-center">
        <p className="text-[#4898a5] font-semibold text-3xl mb-4">Interesting?</p>

        <h2 className="text-4xl md:text-5xl font-bold text-black mb-8 leading-tight">
          Contact us today to
          <br className="hidden sm:block" /> get started on your project.
        </h2>

        <p className="text-gray-700 max-w-3xl mx-auto mb-10 text-lg">
          If you're interested in learning more about our portfolio and the projects we have completed, contact us
          today. We'd love to discuss how we can help you achieve your business goals through exceptional software
          development services.
        </p>

        <Link to="/contact-us" className="bg-[#504e9a] hover:bg-[#3e3b82] text-white font-medium py-3 px-8 transition-colors duration-300">
          Get Started Now
        </Link>
      </div>
    </section>
  );
}

export default CTASection;
